// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b29ad619","726":"27d4a936"}[chunkId] + ".chunk.js";
};